<template>
  <a-form layout="vertical" :model="createFormState">
    <a-form-item label="Nombre del formulario" required>
      <a-input
        v-model:value="createFormState.name"
        placeholder="Escribir nombre del formulario"
        showCount
        :maxlength="45"
      />
    </a-form-item>

    <a-form-item label="Descripción del perfil">
      <a-textarea
        v-model:value="createFormState.description"
        placeholder="Escribir descripción de formulario"
        :autoSize="{ minRows: 4 }"
        showCount
        :maxlength="75"
      />
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { watch, reactive } from "vue";

import { FormCreateBody } from "@/@types/entities/forms/services";

const props = defineProps<{ formState: FormCreateBody }>();

const emit = defineEmits<{
  (e: "update:formState", formState: FormCreateBody): void;
}>();

const createFormState: FormCreateBody = reactive({
  name: props.formState.name,
  description: props.formState.description,
});

watch(createFormState, () => emit("update:formState", createFormState));
</script>

<style scoped lang="sass"></style>
